import React, { useEffect, useState } from "react";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  stringifyData,
} from "../../Pages/utils/page";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
const YourReferral = ({topUsersData}) => {
  const FetchToken = GetLocalStorageParsed("AuthToken");


  const [loginToken, setLoginToken] = useState(FetchToken || null);
  
  return (
    <div className="container">
      <div className="referrals_tabs_data">
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0"></div>
        </div>
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0">
            <div className="row">
              <div className="col-lg-6 col-sm-6 col-6">
                <h4 className="common_heading">Your Referrals</h4>
              </div>
              <div className="col-lg-6 col-sm-6 col-6">
                {topUsersData?.length && (
                  <h4 className="common_heading total-ref_rgt">
                    Total Referrals: {topUsersData?.length}
                  </h4>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-sm-6 col-6"></div>
              <div className="col-lg-6 col-sm-6 col-6">
                {topUsersData?.length && (
                  <h4 className="common_heading total-ref_rgt">
                    Referrals Consumed:{" "}
                    {topUsersData?.filter((i) => i.IsUsed === true)?.length}
                  </h4>
                )}
              </div>
            </div>
            {topUsersData?.length ? (
              <div>
                <div className="table-responsive custom-table-01">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {topUsersData?.map((item, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{item?.Name}</td>
                          <td>{moment(item?.Date).format("DD-MM-YYYY")}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="data_not-availble_box">
                <p className="mb-1">No Data Available !!!</p>
              </div>
            )}
          </div>
        </div>
      </div>{" "}
    
    </div>
  );
};
export default YourReferral;
